window.i18n = {
    "messages": {
        "login": "Inicia sesión",
        "or": "o",
        "create_account": "crea una cuenta",
        "hello_user": "¡Hola, {0}!",
        "logged_in_as": "Iniciaste sesión como",
        "have_account": "¿Ya tienes cuenta PriceTravel?",
        "login_or_create": "para agilizar tu reserva y gestionar tus viajes.",
        "hotel": "HOTEL",
        "who_checkin": "¿Quién hará el check-in?",
        "self_checkin": "Yo",
        "other_checkin": "Otra persona",
        "other_checkin_description": "El alojamiento solicitará una identificación al momento del registro.",
        "adultNew": "Adulto",
        "adultsNew": "Adultos",
        "optional": "(Opcional)",
        "MinorNew": "Menor",
        "MinorsNew": "Menores",
        "years": "años",
        "year": "año",
        "roomNew": "Habitación",
        "typical_food": "Comida típica",
        "dishes_not_miss": "Los platillos que no te puedes perder",
        "country_typical_food": "Comida típica de",
        "read_more": "Leer más detalles",
        "read_less": "Leer menos detalles",
        "see_other_destinations": "Ver otros destinos en",
        "typical_food": "Comida típica",
        "hotels": "Hoteles",
        "break_weekend": "Break de fin de semana",
        "destination_title": "Aprovecha cualquier ocasión para viajar",
        "escape_two_weeks": "Escápate en dos semanas",
        "plan_vacation": "Planea tus vacaciones",
        "enjoy_weather": "Disfruta del clima",
        "tips_weather": "Tips para disfrutar el clima",
        "weather_at": "El clima en",
        "prepare_luggage": "Prepara tu equipaje para",
        "what_expect_weather": "Que esperar del clima en",
        "current_conditions": "Condiciones actuales",
        "code_weather": "°C",
        "min": "min",
        "max": "max",
        "full_forecast": "Pronóstico completo",
        "see_more": "Ver más",
        "see_less": "Ver menos",
        "know_destinations": "Conoce los destinos y opciones para tu viaje en",
        "points_pricetravel": "Puntos de Venta <br/> {0}",
        "select_atention": "Puntos de venta",
        "home": "Inicio",
        "points_pricetravel_desc": "Asesoría personalizada en todo lo que necesitas para tu viaje.",
        "help_you_organize": "Te ayudamos a organizar tu viaje",
        "search_pdv": "Busca tu punto de venta",
        "state": "Estado",
        "all": "Todos",
        "all_images": "Ver todas las imágenes",
        "custom_guide": "Asesoría personalizada ",
        "custom_guide_desc": "Nos aseguramos de brindarte las mejores opciones para cada detalle de tu viaje.",
        "easy_access_schedule": "Fácil acceso y horario extendido",
        "easy_access_schedule_desc": "Estamos ubicados en centros comerciales y abrimos los 7 días de la semana.",
        "pay_easy": "Paga fácil y seguro",
        "pay_easy_desc": "Contamos con diferentes formas de pago y sistema de apartado.",
        "know_paymethods": "Conoce las formas de pago",
        "back_to_list": "Regresar a la lista",
        "open": "Abierto",
        "schedule": "Horario",
        "address": "Dirección",
        "references": "Referencias",
        "select_option": "Elige un estado",
        "phone": "Teléfono",
        "call": "Llamar",
        "closed": "Cerrado",
        "path": "/puntos-de-venta/",
        "wa_contact": "Contactar",
        "see_more_method_payments": "Ver más formas de pago",
        /**Checkout */
        "secure_your_reservation": "¡Asegura tu reservación!",
        "secure_your_reservation2": "Asegura tu reservación",
        "add_your_info_text": "Ingresa tu información para <strong>asegurar la tarifa y disponibilidad</strong> de tu viaje",
        "secure_your_reservationRAPD": "¡Reserva ahora y paga después!",
        "time_to_pay_RAPD": "Te damos más tiempo para pagar tu hospedaje",
        "btn_how_works_RAPD": "Cómo funciona",
        "experts_service": "Nuestros expertos a tu servicio",
        "24_support_text": "Atención 24 horas, 365 días del año",
        "contact_us_btn": "Contáctanos",
        "session_login_session_description2": "Obtén descuentos al instante",
        "session_login_session_description3": "Ahorra hasta 10%  en tu próximo viaje comprando con tu cuenta en {0}",
        "login_text_btn": "Iniciar sesión",
        "register_text_btn": "Crear cuenta",
        "secure_your_reservationRAPDDetail": "Viaja con todos los beneficios: <b>completa el formulario</b>, asegura tu lugar y paga después.",
        "this_is_last_step": "!<strong>Este es el último paso,</strong> sólo da clic y asegura tu lugar!",
        "hurry_up": "¡Apresúrate!",
        "rate_availability_change": "La tarifa y la disponibilidad pueden cambiar en cualquier momento.",
        "enter_your_data_form": "Usaremos esta información para enviarte la confirmación de tu reserva.",
        "enter_your_data_form_com": "Deberá presentar una identificación oficial al llegar al alojamiento.",
        "enter_your_data_form_com_colom": "Deberá presentar una identificación oficial al llegar al alojamiento.",
        "enter_your_data": "Ingresa tus datos",
        "information_contact": "Ingresa tus datos de contacto",
        "method_of_payment": "Forma de pago",
        "confirmation": "Confirmación",
        "first_name": "Nombres",
        "last_name": "Apellidos",
        "email": "Correo electrónico",
        "here_we_send_itinerary": "Aquí enviaremos tu itinerario de viaje",
        "confirm_email": "Confirmar correo electrónico",
        "phone": "Teléfono",
        "continue": "Continuar",
        "i_have_read": "Al hacer click en el botón 'Continuar', usted está aceptando las",
        "privacy_terms_and_reservation_police": "Políticas de reservación y el aviso de privacidad",
        "type_your_first_name": "Escribe tu nombre",
        "type_your_last_name": "Escribe tus apellidos",
        "type_your_email": "Escribe tu email",
        "type_your_email_again": "Confirma tu email",
        "summary_reservation": "Detalles de la reservación",
        "checkin": "Llegada",
        "checkout": "Salida",
        "lodging_days": "noche(s) de hospedaje",
        "taxes_and_fees": "Impuestos",
        "taxes": "impuestos",
        "of_taxes": "de impuestos",
        "total": "Total",
        "stay_of": "Estancia de",
        "taxes_and_fees": "Impuestos y cargos",
        "taxes": "Impuestos",
        "nights": "noches",
        "night": "noche",
        "guests": "Huéspedes",
        "off": "de descuento",
        "room": "habitación",
        "rooms": "habitaciones",
        "rooms-title": "Habitaciones",
        "no-need-pay-today": "No es necesario pagar hoy.",
        "pay-accommodation": "¡Paga en el alojamiento!",
        "all-inclusive": "Todo incluido",
        "guests": "Huéspedes",
        "to": "hasta",
        "price": "Precio",
        "pay-accommodation-title": "Pagarás en el alojamiento",
        "resort-fee": "Cargo del resort",
        "messagge-fee": "Las tarifas {0} son informativas y se basan en el tipo de cambio actual. Pagarás ",
        "messagge-fee-2": " al llegar al alojamiento.",
        "messagge-fee-3": "en pesos mexicanos",
        "months_without_interest": "meses sin intereses",
        "the_best_price": "Mejor precio garantizado",
        "the_best_price_description": "Si encuentras un mejor precio en otra página web para la misma estancia, te lo igualamos.",
        "more_information": "Más información",
        "purchases_safe": "Tus compras en {0} son seguras.",
        "for": "para",
        "adult": "adulto",
        "adults": "adultos",
        "children": "menor",
        "childrens": "menores",
        "and": "y",
        "per": "por",
        "you_may": "Puedes",
        "cancel_free": "cancelar gratis",
        "reservation_until": "esta reservación hasta el",
        "reservation_until_h_c": "Hasta el",
        "free_cancellation": "Cancelación GRATIS",
        "free_cancellation_room": "Cancelación gratuita",
        "reservation_until_room": "hasta el",
        "checkout_title": "Checkout",
        "dates_server_cancellation": "Las fechas y horas corresponden al huso horario de la Ciudad de México.",
        "description_cancellation_free": "Cancelación GRATIS hasta las 23:59 hrs del",
        "description_cancellation_free_to": "a partir de las 00:00 hrs del",
        "description_cancellation_penalty": "tu reservación tendrá penalidad",
        "close": "Cerrar",
        "cancellation_policy": "Políticas de cancelación",
        "success_voucher": "Genial, ¡Prepárate para viajar!",
        "processing_booking": "Estamos procesando tu reservación",
        "reservacion_id": "Localizador:",
        "we_send_email": "Enviamos los detalles al correo",
        "description_voucher": "Asegurate de recibir nuestros mensajes",
        "description_voucher_detail": "Si después de unos minutos no ves nuestro mensaje en tu correo, revisa la carpeta de spam, si está ahí, márcalo como correo seguro para que recibar sin problema los correos de {0}",
        "go_home": "Regresar al inicio",
        "thankyou_page": "Confirmación de compra",
        "error_title": "Ha ocurrido un error",
        "error_description": "Nuestras disculpas. No pudimos obtener la información solicitada.",
        "error_list_one": "Los servidores eliminan la información de búsqueda después de un tiempo de inactividad. Esto protege tu privacidad y ayuda a que el sitio funcione mejor.",
        "error_list_two_bold": "Enlace desde favoritos",
        "error_list_two": "Las páginas que agregas a tus favoritos(bookmarks) de tu navegador, están construidas con información que se basa en tus selecciones previas (como tarifas para una fecha específica). Estas páginas no se pueden usar para obtener información actualizada.",
        "RATE_NOT_FOUND": "Ha ocurrido un error con la cotizacion actual, por favor comunicate al telefono <a href='tel:5586638825'>55 8663 8825 </a> para el seguimiento",
        "ROOM_NOT_FOUND": "Ha ocurrido un error con la cotizacion actual, por favor comunicate al telefono <a href='tel:5586638825'>55 8663 8825 </a> para el seguimiento",
        "HOTEL_NOT_FOUND": "No se ha encontrado el hotel",
        "VOUCHER_NOT_FOUND": "Datos no encontrados",
        "ERROR_DEFAULT": "Se ha producido un error",
        "rapd_title_summary": "Reserva ahora y paga después",
        "total_reservation": "Total de tu reservación",
        "total_booknow": "Paga ahora:",
        "date_limit_booknow": "Paga antes de",
        "midday": "medio día",
        "tax_include": "incluidos",
        "tax_no_include": "no incluidos",
        "bags": "¡Tu reserva esta lista!",
        "reservation_number": "Tu número de reservación es",
        "email_reservation_voucher": "Te enviamos un correo de confirmación a",
        "email_reservation_voucher_description": "Recuerda presentar tu número de reservación y una identificación oficial vigente.",
        "download_itinerary": "Ver Itinerario",
        "date_checkin_checkout": "Fecha de llegada y salida",
        "paxes": "Huéspedes",
        "room_type": "Tipo de habitación",
        "mealplan": "Plan de alimentos",
        "payment_method": "Método de pago",
        "payment_plan": "Plan de pago",
        "payment_total": "Total pagado",
        "get_invoice": "Obtener factura",
        "cancellation_polcy": "Política de cancelación",
        "cancellation_polcy_legal": "Tu reservación cuenta con un periodo donde no aplican penalidades si cancelas tu reservación. Toma en cuenta que este periodo tiene una duración fija. Revisa detalles y penalidades en tu itinerario.",
        "reservation_holder": "Títular de la reservación",
        "reservation_holder_booking": "Ingresa los datos de la persona que realizará el checkin en el hotel",
        "reservation_card": "Reserva sin tarjeta de crédito.",
        "price_and_availible": "Precio y disponibilidad garantizados.",
        "payment_later_interes": "Paga después a meses sin intereses.",
        "residents_colo": "Residentes colombianos",
        "residents_peru": "Residentes de Perú",
        "detail_residents_colo": "Para reservas y estadías hasta el 31 de diciembre de 2022, de acuerdo a la ley 2068 de 2020, rige IVA de alojamiento al 0%. Para estadías a partir del 1 de enero 2023, colombianos deberán pagar IVA (diecinueve por ciento) directo en el hotel.",
        "detail_residents_peru": "*** Es posible que los residentes de Perú deban pagar el IVA (impuesto al valor agregado) nacional (18%) en la propiedad. Los turistas extranjeros que presenten una visa de turismo o Tarjeta Andina de Migración y un pasaporte válido pueden estar exentos del pago de este impuesto.",
        "residents_extran_detail_info": "  El impuesto del IVA aplica también para extranjeros que permanezcan en el país al menos 60 días consecutivos. El impuesto podría aplicar para toda la habitación en caso de compartir con una persona sujeta a pagar el impuesto.",
        "residents_extran": "Extranjeros",
        "residents_extran_detail_info_2": "De acuerdo al Decreto 2646 del Ministerio de Hacienda y Crédito Público de Colombia, quedan exentos del pago del impuesto aquellas personas residentes del exterior que adquieran un plan o paquete turístico (hospedaje + alguna de las comidas o traslado) y presenten en el hotel su pasaporte con los correspondientes sellos migratorios de la aduana de Colombia que acrediten el debido ingreso. Dicho proceso será válido siempre que el ingreso al hotel sea en un periodo no mayor a 30 días de ingresado al país.",
        "please_wait_voucher": "Estamos procesando tu reservación, por favor espere un momento.",
        "please_wait_voucher_loader": "Esto puede tardar unos segundos. Porfavor no cierres la página.",
        "resort_fee": "Tarifa del resort:",
        "resort_feeTitle": "Tarifa del resort *",
        "resort_fee_pt1": "Se te solicitará el pago de la tarifa del resort de",
        "resort_fee_pt2": "El pago se realizará en la moneda local y al tipo de cambio vigente.",
        "colombians_vat_messages": "*Para estadias a partir del 1 de enero 2023, colombianos deberan pagar IVA 19% directo en el hotel.",
        "resort_pay_now": "Paga ahora",
        "resort_at_property": "Paga en la propiedad",
        "charges_not_included_sub": "Te los cobrará el alojamiento cuando llegues al destino.",
        "how_make_payment": "Cómo hacer tu pago",
        "rapd_instruction1": "Haz tu pago antes de la fecha límite",
        "rapd_instruction2": "Paga a meses sin intereses con tarjetas participantes",
        "rapd_instruction3": "Elige la opción que más te convenga",
        "pay_online": "Paga en línea",
        "with_credit_or_debit": "Con tarjeta de crédito o débito",
        "see_details_in_email": "Consulta los detalles en el correo que te enviamos",
        "pay_by_phone": "Pagar por teléfono",
        "pay_bank_transfer": "Paga con tarjeta de crédito, débito o transferencia bancaria",
        "pay_on_pdvs": "Paga en Puntos de Venta {0}",
        "go_to_our_pdvs": "Acude a cualquiera de nuestros puntos de venta y paga con tarjeta de crédito, débito o efectivo",
        "consult_the_list_pdvs": "Consulta la lista de Puntos de Venta {0}",
        "booked_with_rapd_benefit": 'Reservaste con el beneficio <strong class="promo-text">reserva ahora y paga después</strong>',
        "phone_number_pay": "55 8663 8825",
        "phone_number_pay_href": "5586638825",
        "your_reservation_is_confirmed": "Tu reservación está confirmada",
        "source_triv_gool": "Costo final de tu reserva:",
        "use_coupon": " ¡Usa el cupón {0} al reservar.",
        "special_requests": "Solicitudes especiales (opcional)",
        "we_send_your_requests": "Enviaremos tus solicitudes al hotel; sin embargo, están sujetas a disponibilidad y posibles cargos adicionales.",
        "special_request_placeh": "Escribe si necesitas algo en especial para tu estancia (ej. cunas, camas extra, etc)",
        "with_credit_card": "meses sin intereses",
        "reservation_message": "Usa este número para dar seguimiento a tu reserva con",
        "site_name": "{0}",
        "review_itinerary": "Revisar Itinerario",
        "pay_aloj": "Pagarás en el alojamiento",
        "pay_hotel_collect": "Pagarás en el alojamiento",
        "pay_hotel_collect_1": "Las tarifas en pesos mexicanos son informativas y se basan en el tipo de cambio actual. Pagarás",
        "pay_hotel_collect_2": "al llegar al alojamiento",
        "discount_title": "¡Encontramos un mejor precio!",
        "discount_title_2": "Ya tienes el mejor precio disponible",
        "discount_subtitle": "Aplicar descuento de",
        "discoubt_title_btn": "Aplicar",
        "discoubt_title_btn_delete": "Eliminar",
        "discount_subtitle_2": "en tu reservación",
        "discount_applicable": "Se aplicó un descuento de",
        "error_reserv": "Lo sentimos. La opción seleccionada ya no está disponible.",
        "discount_applicable": "Se aplicó un descuento de",
        "error_reserv": "Lo sentimos. La opción seleccionada ya no está disponible.",
        "wa_contact": "Contactar",
        "Show_room_details": "Mostrar detalles de habitación",
        "hide_room_details": "Ocultar detalles de habitación",
        "Total_length_of_stay": "Duración de la estancia",
        "you_choose": "Seleccionaste",
        "traveler_information": "Información del viajero",
        "step_1_of_2": "Paso 1 de 2",
        "book_now_pay_later": "¡Reserva ahora y paga después!",
        "enter_your_details": "¡Asegura tu reservación!",
        "payment_not_required_today": "¡No necesitas pagar hoy!",
        "pay_at_property": "Realiza el pago en la propiedad.",
        "travel_with_benefits": "Viaja con todos los beneficios:",
        "complete_form_secure_place": "completa el formulario, asegura tu lugar y paga después.",
        "reserve_without_credit_card": "Reserva sin tarjeta de crédito.",
        "guaranteed_price_availability": "Precio y disponibilidad garantizados.",
        "accept_reservation": "Al hacer clic en el botón \"Continuar\", acepto las",
        "policies_privacy_notice": "políticas de reservación y nuestro aviso de privacidad.",
        "continue2": "Continuar",
        "payment": "Método de pago",
        "whos_checking": "¿Quién hará el check-in?",
        "where_do_send": "¿A dónde enviamos tu confirmación?",
        "placeholder_name": "Alex",
        "placeholder_lastname": "Torres",
        "placeholder_email": "tucorreo@ejemplo.com",
        "placeholder_phone": "55 6530 5632",
        "get_ready_travel": "¡Prepárate para viajar, ",
        "get_ready_travelrapd": "¡Tu reservación está confirmada, ",
        "get_ready_traveldeposit": "¡Estás a un paso de asegurar tu viaje, ",
        "get_ready_travelcollect": "¡Tu hospedaje te espera, ",
        "get_ready_travelprocess": "¡Estamos procesando tu pago, ",
        "get_ready_travelefecty": "¡Estás a un paso de asegurar tu viaje, ",
        "processing_payment": "Estamos procesando tu pago",
        "processing_payment_reservation": "Estamos procesando tu reserva, ",
        "thank_you_choosing": "Gracias por elegir PriceTravel. Todavía estamos procesando tu pago. Enviaremos un correo electrónico con la confirmación de tu reservación a:",
        "thank_you_choosing_processing": "Si en los próximos minutos no llega a {0}, por favor contáctanos",
        "thank_you_choosing_processing_2": " por favor contáctanos al ",
        "thank_you_choosing_processing_3": " para ayudarte.",
        "thank_you_choosingrapd": "Tu reservación se está procesando y en breve recibirás un correo con todos los detalles.",
        "use_locator_number": "Utilice este número de localizador para hacer seguimiento o resolver cualquier duda sobre su reserva con {0}.",
        "your_reservation": "Tu reservación",
        "pay_later_how": "¡Paga después! ¿Cómo hacer tu pago?",
        "pay_at_accommodation": "Pagarás en el alojamiento",
        "thank_you_processing": "Gracias por elegir PriceTravel, estamos procesando tu reserva",
        "email_confirmation": "Te enviaremos un correo electrónico confirmando tu reserva a:",
        "email_confirmationrapd": "Te enviaremos un correo con todos los detalles a ",
        "email_confirmationcollet": "Te enviamos los detalles también por correo a ",
        "send_payment_link": "Te enviaremos un correo electrónico con todos los detalles que necesitas para pagar en línea a",
        "no_locator": "No. de reservación",
        "use_number_locator": "Úsalo para dar seguimiento a tu reserva.",
        "check_itinerary": "Revisar itinerario",
        "need_anything_else": "¿necesitas algo más para tu viaje?",
        "reserve_flight": "Reserva un vuelo",
        "buy_flights_best_price": "Compra miles de vuelos al mejor precio.",
        "view_more": "ver más",
        "special_deals": "Ofertas especiales",
        "find_best_deals_travel": "Encuentra las mejores ofertas y viaja ahora.",
        "summary_payment": "Resumen de pago",
        "tax": "Impuestos",
        "plural_suffix": "es",
        "you_w_pay_upon_arr": "Los cargos adicionales se pagan al llegar al alojamiento y son calculados según el tipo de cambio actual, el cual puede variar al momento del viaje.",
        "you_w_pay_upon_arr_trivago": "Los cargos a pagar en la propiedad se calculan según el tipo de cambio actual, el cual puede variar al momento del viaje.",
        "thankSite": "¡Gracias por elegir {0}!",
        "completepayrapd": "Tu lugar está garantizado, pero recuerda:<br>para completar tu reservación necesitas realizar el pago antes de la fecha límite.",
        "preferenrapd": "O, si lo prefieres, puedes pagar tu reserva llamando al",
        "hotelcollectmsg": "Recuerda que el pago se realizará directamente en el alojamiento.",
        "efectymsg": "Descarga la información de pago con los datos necesarios para realizar tu pago",
        "procespay": "Aún estamos procesando tu pago. Te enviaremos un correo electrónico con la confirmación de tu reserva a: ",
        "depositmsgmain": "Descarga la información de pago con los datos necesarios para realizar tu transferencia interbancaria o depósito.",
        "amounttopay": "Monto a pagar:",
        "amounttopaycollect": "Pagarás en el alojamiento:",
        "amoutpaydate": "Pagar antes de:",
        "amoutpaydateprint": "Fecha límite de pago:",
        "triptraslate": "Traslado:",
        "tripsecure": "Seguro:",
        "tripcar": "Auto:",
        "triptour": "Tours:",
        "printtitle": "Realiza tu pago y ¡prepárate para viajar!",
        "printresume": "RESUMEN DE TU RESERVA",
        "printmensaje": "Si no recibimos tu pago a tiempo tu reservación será cancelada.",
        "printisntruccion": "INSTRUCCIONES PARA PAGAR",
        "printisntruccionmsg_pricetravel": "Haz una transferencia o depósito en el banco de tu preferencia.",
        "printisntruccionmsg_tiquetesbaratos": "¿Cómo pagar con depósito bancario?",
        "printaccounts": "Cuentas bancarias",
        "printcount": "Cuenta: ",
        "printclabe": "CLABE: ",
        "printulite": "Una vez realizado tu pago",
        "printfinalice": "Envía un correo a pagosbancarios@pricetravel.com, indicando tu número de reservación y adjuntando una imagen legible de tu comprobante de pago. ",
        "pritcall": "Llama al {0} y verifica con un asesor que tu pago fue recibido.",
        "printalert": "Si tu pago no es reportado y validado por uno de nuestros asesores antes de la fecha y hora límite no podremos garantizar tu reservación o la tarifa de los servicios cotizados.",
        "amoutpaytime": "Si no recibimos tu pago a tiempo tu reservación será cancelada automáticamente.",
        "rapdonlyfalt": "Solo falta tu pago para asegurar el viaje",
        "collect_fees": "Las tarifas en {0} son informativas y se basan en el tipo de cambio actual.",
        "collect_fees2": " El pago se realizará en {0}",
        "title_card_deposit": "Haz tu pago por transferencia antes de la fecha límite",
        "title_efecty": "Haz tu pago con Efecty",
        "btnItineraryDeposit": "Descargar información de pago",
        "complementary_summary": "Detalle de la reservación",
        "complementary_summary_payment": "Resumen de pago",
        "accept_cards": "Aceptamos todas las tarjetas. ",
        "secure_purchase": "Compra 100% segura. ",
        "best_price": "¡Mejor precio garantizado!",
        "information_important": "Información importante para tu reserva",
        "impuest_local": "Impuesto solo para residentes locales <span class=\"\">IVA 18%</span>",
        "impuest_local_colo": "Impuesto solo para residentes locales <span class=\"\">IVA 19%</span>",
        "redesidentes_peru": "Residentes peruanos:",
        "redesidentes_peru_detail": "Deberán pagar un IVA nacional (18%) directo en el alojamiento.",
        "redesidentes_extran": "Residentes extranjeros:",
        "redesidentes_extran_detail": "Los turistas extranjeros que presenten una visa de turismo o Tarjeta Andina de Migración y un pasaporte válido pueden estar exentos del pago del IVA nacional.",
        "close_modal_peru": "Cerrar",
        "redesidentes_colo": "Residentes colombianos:",
        "redesidentes_colo_detail": "De acuerdo al Decreto 2646 del Ministerio de Hacienda y Crédito Público de Colombia, residentes colombianos deberán pagar un impuesto del IVA (19%) directo en el hotel. El impuesto podría aplicar para toda la habitación en caso de compartir con una persona sujeta a pagar el impuesto.",
        "redesidentes_extran_colo_detail": "Extranjeros que permanezcan en el país de Colombia al menos 60 días consecutivos, deberán pagar el impuesto del IVA (19%) directo en el hotel. El impuesto podría aplicar para toda la habitación en caso de compartir con una persona sujeta a pagar el impuesto. Excepciones: De acuerdo al Decreto 2646 del Ministerio de Hacienda y Crédito Público de Colombia, quedan exentos del pago del impuesto aquellas personas residentes del exterior que adquieran un plan o paquete turístico(hospedaje + alguna de las comidas o traslado) y presenten en el hotel su pasaporte con los correspondientes sellos migratorios de la aduana de Colombia que acrediten el debido ingreso. Dicho proceso será válido siempre que el ingreso al hotel sea en un periodo no mayor a 30 días de ingresado al país.",
        "your_offer": "Tu hotel fue:",
        "offer_wow": "Oferta Misteriosa {0}",
        "offer_wow_subtitle": "¡Finaliza tu reservación y déjate sorprender!",
        "offer_wow_subtitle_2": "Al confirmar tu compra, desbloquearás uno de nuestros hoteles seleccionados.",

        "invoice_name": "Nombre completo / Razón social",
        "invoice_email": "Correo electrónico de facturación",
        "invoice_tiquetesbaratos_code": "Número de documento / NIT / RUT",
        "invoice_pricetravel_code": "Número de documento / RFC / Tax ID",
        "invoice_type": "Documento de identidad",
        "invoice_tiquetesbaratos_hide": "Selecciona un documento",
        "invoice_pricetravel_hide": "Selecciona un documento",
        "invoice_title": "Facturación",
        "invoice_check": "Necesito facturar mi compra",
        "invoice_description": "La factura llegará en las proximas 24 horas al correo de su reservación después de la confirmación.",

        "invoice_pricetravel_nit": "RFC / Tax ID / NIF",
        "invoice_pricetravel_cc": "Cedula de ciudadanía",
        "invoice_pricetravel_ti": "Tarjeta de identidad",
        "invoice_pricetravel_pp": "Pasaporte",
        "invoice_pricetravel_ce": "Cedula de extranjería",
        "invoice_pricetravel_other": "Otro",

        "invoice_tiquetesbaratos_nit": "NIT / RUT (con dígito verificador)",
        "invoice_tiquetesbaratos_cc": "Cedula de ciudadanía",
        "invoice_tiquetesbaratos_ti": "Tarjeta de identidad",
        "invoice_tiquetesbaratos_pp": "Pasaporte",
        "invoice_tiquetesbaratos_ce": "Cedula de extranjería",
        "invoice_tiquetesbaratos_other": "Otro",
        "nothing_search_results": "No se encontraron resultados",
        "invoice_save_data": "Tus datos de facturación guardados",

        "transfer_pricetravel": "Traslado redondo",
        "transfer_tiquetesbaratos": "Traslado Ida y regreso",
        "transfers": "Traslado",
        "transfer_detail": "Aeropuerto - Hotel -Aeropuerto",
        "add_complementary": "Agrega complementos para tu viaje",
        "continue_with_searchpricetravel": "Tus búsquedas recientes",
        "print_payment": "Realiza la consignación en cualquiera de las siguientes cuentas bancarias.",
        "print_payment_whatsapp": "Reporta tu pago por WhatsApp al +{0} o comunícate con nuestra línea de atención al cliente: {1}.",
        "print_payment_confirm": "Una vez confirmado tu pago, tu reservación será emitida y enviada al correo registrado",
        "print_payment_time": "Horarios habilitados para confirmar consignaciones:",
        "print_payment_time_detail": "Lunes a viernes: 07:00 AM - 10:00 PM <br>Sábados, domingos y festivos: 07:00 AM - 09:00 PM",
        "print_bank_account": "DATOS BANCARIOS",
        "print_bank_account_title": "Titular:",
        "print_bank_account_confirm": "Envía tu comprobante por WhatsApp al +{0} o por correo si te lo indican nuestros asesores.",
        "print_bank_account_confirm_detail": "Asegúrate de incluir tu número de reservación y nombre completo en el comprobante.",
        "print_bank_account_confirm_confirm": "Espera la confirmación oficial por parte de nuestro equipo.",
        "print_bank_account_confirm_confirm_detail": "Una vez validado tu pago, recibirás el correo de confirmación con los detalles de tu viaje.",
        "print_important": "Importante",
        "print_tariff_guarantee": "La tarifa solo se garantiza una vez sea reportada la consignación a nuestras líneas de atención al cliente.",
        "print_payment_guarantee": "Vuelos Tiquetes Baratos no se hace responsable por la expedición de tiquetes si su pago no es reportado y confirmado a uno de nuestros asesores. Solo pagos en efectivo, no se aceptan cheques.",
        "print_bank_account_guarantee": "Ofrecemos la opción de consignación bancaria para nuestros clientes como otra forma para facilitar su pago. Conforme al Artículo 4 de la Resolución No. 3596 de 2006, modificado por la resolución 4561 de octubre 30 de 2006 expedida por la Aeronáutica Civil, se debe cobrar un valor de Tarifa Administrativa mayor por el hecho de haber intervención humana.",
        "print_bank_account_guarantee_detail": "Consulta oficial: <a href=\"https://www.aerocivil.gov.co/consulta-de-tarifas/\" style=\"font-weight: 400;color: #000;text-decoration: underline;\"  target=\"_blank\">www.aerocivil.gov.co</a>",
        //EFECTY
        "print_payment_efecty": "¿Cómo pagar con Efecty?",
        "print_payment_efecty_detail": "Descarga el código de convenio y la referencia de pago que te mostramos abajo.",
        "print_payment_efecty_confirm": "Dirígete a un Punto de atención con estos datos y realiza tu pago en efectivo.",
        "print_payment_efecty_confirm_detail": "Recibirás un correo de confirmación una vez finalizado el pago.",
        "print_payment_efecty_time": "Tienes plazo hasta el <strong>{0}</strong> para pagar. Si no lo haces, tu reserva<br> será cancelada.",
        "print_payment_efecty_code": "Código de convenio:",
        "print_payment_efecty_reference": "Referencia de pago:",
        "print_payment_efecty_no_confirm": "No recibiste confirmación en 12 horas? Escríbenos al",
        "print_payment_efecty_no_confirm_time": "a las",

        "insurance": "Seguro de viaje",
        "continue_with_searchtiquetesbaratos": "Tus búsquedas recientes"
    },
    "weather": {
        "weather200": "Tormenta con lluvia ligera",
        "weather201": "Tormenta con lluvia",
        "weather202": "Tormenta con lluvia torrencial",
        "weather210": "Tormenta eléctrica",
        "weather211": "Tormenta",
        "weather212": "Fuerte tormenta",
        "weather221": "Tormenta rajada",
        "weather230": "Tormenta con llovizna ligera",
        "weather231": "Tormenta con llovizna",
        "weather232": "Tormenta con llovizna pesada",
        "weather300": "Llovizna",
        "weather301": "Llovizna",
        "weather302": "Llovizna",
        "weather310": "Lluvia",
        "weather311": "Lluvia",
        "weather312": "Lluvia",
        "weather313": "Lluvia",
        "weather314": "Lluvia",
        "weather321": "Lluvia",
        "weather500": "Lluvia Ligera",
        "weather501": "Lluvia Moderada",
        "weather502": "Lluvia fuerte",
        "weather503": "Lluvias Muy Intensas",
        "weather504": "Lluvia Extrema",
        "weather511": "Llluvia Helada",
        "weather520": "Lluvia",
        "weather521": "Aguacero",
        "weather522": "Lluvia fuerte",
        "weather531": "Lluvia torrencial",
        "weather600": "Nieve ligera",
        "weather601": "Nieve",
        "weather602": "Fuertes nevadas",
        "weather611": "Aguanieve",
        "weather612": "Aguanieve",
        "weather615": "Lluvia ligera y nieve",
        "weather616": "Lluvia y nieve",
        "weather620": "Nieve ligera",
        "weather621": "Nieve",
        "weather622": "Fuerte lluvia y nieve",
        "weather701": "Niebla",
        "weather711": "Fumar",
        "weather721": "Calina",
        "weather741": "Niebla",
        "weather800": "Cielo Limpio",
        "weather801": "Pocas nubes",
        "weather802": "Nubes dispersas",
        "weather803": "Pocas nubes",
        "weather804": "Nublado",
        "weather900": "Tornado",
        "weather901": "Tormenta Tropical",
        "weather902": "Huracán ",
        "weather903": "Frio",
        "weather904": "Caliente",
        "weather905": "Ventoso",
        "weather906": "Granizo",
        "weather951": "Calma",
        "weather952": "Brisa ligera",
        "weather953": "Suave brisa",
        "weather954": "Brisa moderada",
        "weather955": "Brisa Fresca",
        "weather956": "Brisa fuerte",
        "weather957": "Viento Fuerte",
        "weather958": "Viento con gran intensidad",
        "weather959": "Viento con gran intensidad",
        "weather960": "Tormenta",
        "weather961": "Tormenta Violenta",
        "weather962": "Huracán "
    },
    "url": {
        "root": "",
        "hotels_path": "hoteles",
        "url_terms_pricetravel": "/legal/terms-and-conditions",
        "url_terms_tiquetesbaratos": "/assets-tb/files/terminos-condiciones.pdf",
        "url_best_price": "/ayuda/garantia-precios",
        "url_go_home": "/",
        "url_go_itinerary_pricetravel": "/help-center/itinerary",
        "url_go_itinerary_tiquetesbaratos": "/help-center/itinerary",
        "url_detail": "/hotel/",
        "url_list": "/hoteles/",
        "url_pdv": "/puntos-de-atencion",
        "url_destination": "destino",
        "url_flights": "/vuelos",
        "url_tours_pricetravel": "/es/ofertas-de-viajes",
        "url_tours_tiquetesbaratos": "/vuelos/promociones-tiquetes-aereos-origen"
    },
    "mealplans": {
        "A": "Desayuno americano",
        "AA": "Navidad y Fin de Año Imperial",
        "AB": "Escapada Romántica",
        "AC": "Escapada Romántica y Spa",
        "AZ": "Todo Incluido",
        "AD": "Comida y cena con bebidas incluidas",
        "AE": "Desayuno (solo adultos)",
        "AF": "Desayuno Gourmet Americano",
        "AG": "Desayuno para 2",
        "AH": "Desayuno Continental para 2",
        "AI": "Desayuno y Almuerzo",
        "AJ": "Desayuno, almuerzo, cena, con liquidos",
        "AK": "Semi todo incluido",
        "AL": "3 comidas + 2 snacks",
        "AM": "Dining Plan",
        "AN": "Quick Service",
        "AO": "Desayuno, comida o cena, sin líquidos",
        "AP": "Desayuno, merienda y cena",
        "AQ": "Desayuno, almuerzo o cena",
        "AR": "No Reembolsable",
        "AS": "Bebidas Incluidas",
        "AT": "Desayuno, comida y cena solo adultos",
        "AU": "Desayuno continental solo adultos",
        "AV": "Desayuno",
        "AW": "Alimentos, Bebidas y Tours Incluidos",
        "AX": "Desayuno para 1 adulto",
        "AY": "Cena",
        "B": "Desayuno bufet",
        "C": "Comida",
        "E": "Solo alojamiento",
        "F": "Desayuno y cena incluidos",
        "G": "Desayuno, comida y cena",
        "H": "Desayuno, comida o cena",
        "I": "Todo incluido",
        "J": "Desayuno bufet continental",
        "K": "Alimentos y bebidas incluidas",
        "L": "Desayuno",
        "M": "Desayuno y cena con bebidas incluidas",
        "N": "Desayuno sin líquidos",
        "O": "Barra libre",
        "P": "Desayuno y cena, sin liquidos",
        "Q": "Desayuno, almuerzo y cena, sin liquidos",
        "R": "Desayuno bufet sin bebidas",
        "S": "Desayuno y comida o cena, sin líquidos",
        "T": "Comida sin líquidos",
        "U": "2 comidas quick service + 1 snack",
        "V": "2 comidas + 1 snack",
        "W": "3 alimentos sin bebidas",
        "X": "Cena sin líquidos",
        "Y": "Desayuno continental sin líquidos",
        "Z": "Desayuno continental"
    },
    "breakdown": {
        "TaxExcluded": "Impuestos no incluidos",
        "TaxExcluded_CO": "Impuesto solo a residentes locales",
        "TaxIncluded": "Impuestos incluidos",
        "HotelFees": "Tarifas de hotel",
        "ResortFees_tiquetesbaratos": "Cargos del alojamiento",
        "ResortFees_pricetravel": "Cargos del Resort",
        "ResortFee_tiquetesbaratos": "Cargos del alojamiento",
        "ResortFee_pricetravel": "Cargo del Resort",
        "ResortFees_sub": "a pagar en el alojamiento",
        "ResortFee_sub": "a pagar en el alojamiento",
        "HotelMandatoryTax_sub": "a pagar en el alojamiento",
        "HotelMandatoryFee_sub": "a pagar en el alojamiento",
        "HotelMandatoryTax_tiquetesbaratos": "Impuesto solo a residentes locales",
        "HotelMandatoryTax_pricetravel": "Impuesto local",
        "HotelMandatoryFee": "Impuestos obligatorios del hotel",
        "HospitalityTax": "Seguro hotelero",
        "HospitalityTax_sub": "Por persona para la estadía completa",
        "charges_not_included": "Cargos adicionales",
        "HotelMandatoryService_tiquetesbaratos": "Cargos del alojamiento",
        "HotelMandatoryService_pricetravel": "Cargo por servicio de alojamiento",
        "HotelMandatoryService_sub": "a pagar en el alojamiento",
        "cleaning-fee": "Cargo por limpieza",
        "to_pay_at_accommodation": "A pagar en el alojamiento",
        "title_taxes": "Desglose de Cargos",
        "non_refundable": "No reembolsable",
        "included": "Incluido",
        "partial_cancellation": "Cancelación con cargos parciales",
        "view_price_breakdown": "Ver desglose de precio",
        "local-tax": "impuesto local",
        "vat": "iva",
        "tourist-tax": "impuesto turístico",
        "goods-and-services-tax": "impuesto sobre bienes y servicios",
        "city-tax": "impuesto municipal",
        "towels-fee": "cargo por toallas",
        "electricity-fee": "cargo por electricidad",
        "bed-linen-fee": "cargo por ropa de cama",
        "gas-fee": "cargo por gas",
        "oil-fee": "cargo por aceite",
        "wood-fee": "cargo por leña",
        "water-usage-fee": "cargo por uso de agua",
        "transfer-fee": "cargo por traslado",
        "linen-package-fee": "cargo por paquete de ropa de cama",
        "heating-fee": "cargo por calefacción",
        "air-conditioning-fee": "cargo por aire acondicionado",
        "kitchen-linen-fee": "cargo por ropa de cocina",
        "housekeeping-fee": "cargo por limpieza",
        "airport-shuttle-fee": "cargo por transporte al aeropuerto",
        "shuttle-boat-fee": "cargo por transporte en barco",
        "sea-plane-fee": "cargo por hidroavión",
        "ski-pass": "pase de esquí",
        "wristband-fee": "cargo por pulsera",
        "visa-support-fee": "cargo por apoyo de visa",
        "water-park-fee": "cargo por parque acuático",
        "club-card-fee": "cargo por tarjeta de club",
        "conservation-fee": "cargo de conservación",
        "credit-card-fee": "cargo por tarjeta de crédito",
        "pet-fee": "cargo por mascota",
        "internet-fee": "cargo por internet",
        "unknown": "desconocido",
        "parking-fee": "cargo por estacionamiento",
        "insurance": "seguro",
        "service-fee": "cargo por servicio",
        "resort-fee": "cargo de resort",
        "booking-fee": "cargo por reserva",
        "tourism-fee": "cargo turístico",
        "destination-fee": "cargo de destino",
        "extra-bed-fee": "cargo por cama extra",
        "environment-fee": "cargo ambiental",
        "children-extra-fee": "cargo extra por niños",
        "cleaning-fee": "cargo de limpieza",
        "book-direct-service-fee": "cargo por servicio de reserva directa",
        "airbnb-short-term-cleaning-fee": "cargo de limpieza corta estancia airbnb",
        "state-tax": "impuesto estatal",
        "county-tax": "impuesto del condado",
        "occupancy-tax": "impuesto de ocupación",
        "transient-occupancy-tax": "impuesto de ocupación temporal",
        "home-sharing-tax": "impuesto de alquiler compartido",
        "harmonized-sales-tax": "impuesto armonizado de ventas",
        "minimum-alternate-tax": "impuesto mínimo alternativo",
        "early-check-in": "check-in temprano",
        "late-checkout": "check-out tardío",
        "deposit": "depósito",
        "food": "comida",
        "laundry": "lavandería",
        "management": "gestión",
        "pool": "piscina",
        "pool-heating": "calefacción de piscina",
        "toiletries": "artículos de aseo",
        "tour": "tour",
        "car-rental": "alquiler de coche",
        "additional-charge": "cargo adicional",
        "miscellaneous": "misceláneo",
        "shipping": "envío",
        "activities": "actividades",
        "flights": "vuelos",
        "gift-basket": "cesta de regalo",
        "chef": "chef",
        "meet-and-greet": "recepción y bienvenida",
        "dock-fee": "cargo por muelle",
        "utility-fee": "cargo de servicios",
        "hot-tub-fee": "cargo por jacuzzi",
        "breakfast": "desayuno",
        "beverage": "bebida",
        "meal": "comida",
        "minibar": "minibar",
        "business-center": "centro de negocios",
        "equipment-rental": "alquiler de equipo",
        "damage-charge": "cargo por daños",
        "homeowners-association": "asociación de propietarios",
        "golf-cart-rental": "alquiler de carrito de golf",
        "additional-cleaning-fee": "cargo adicional de limpieza",
        "community-fee": "cargo comunitario",
        "early-checkout": "check-out temprano",
        "late-check-in": "check-in tardío"
    },
    "transfer": {
        "title_pricetravel": "Traslado ida y vuelta Aeropuerto - Hotel ",
        "title_tiquetesbaratos": "Traslado ida Y regreso Aeropuerto - Hotel",
        "from": "Punto de partida:",
        "note": "Si necesitas un traslado desde otro aeropuerto, contáctanos por teléfono.",
        "to": "Ida: ",
        "flight": "Vuelo",
        "time": "Hora:",
        "return": "Regreso: ",
        "service": "Servicio compartido",
        "total": "Precio total:",
        "add": "Agregar",
        "remove": "Eliminar",
        "flight_info": "Información de vuelos",
        "arrival": "VUELO DE LLEGADA:",
        "departure": "VUELO DE REGRESO:",
        "airline": "Aerolínea",
        "flight_number": "Número de vuelo",
        "arrival_time": "Hora de llegada",
        "departure_time": "Hora de salida",
        "info": "¿No tienes los datos aún?, no te preocupes. Podrás comunicarte después para especificar los datos de tu vuelo",
        "add_button": "Agregar",
        "add_transfer": "AGREGADO",
        "total_person": "Para {0} personas"
    },
    "insurance": {
        "title_pricetravel": "Seguro de Viaje",
        "title_tiquetesbaratos": "Seguro de Viaje",
        "add": "Agregar",
        "remove": "Eliminar",
        "coverage_includes": "Ver detalles de cobertura",
        "total": "Precio total:",
        "modal_title": "Coberturas del Seguro",
        "summary_title": "Resumen de coberturas",
        "pdf_links_title": "Enlaces de PDF",
        "notes_title": "Notas",
        "close": "Cerrar",
        "total_person": "Para {0} personas",
        "medical_assistance": "Asistencia médica",
        "add_complementary": "AGREGADO",
        "loss_compensation": "Compensación por pérdida de equipaje",
    },
    "errors": {
        "_default": "The field is not valid",
        "alpha": "alpha",
        "alpha_spaces": "alpha_spaces",
        "confirmed": "confirmed",
        "email": "email",
        "required": "required",
        "integer": "integer",
        "min": "min",
        "number": "number",
        "date_invalid": "date_invalid",
        "date_expiration": "date_expiration",
        "alpha_num_strict": "alpha_num_strict"
    },
    "customErrorMessages": {
        "first_name": {
            "required": "Escribe su(s) nombre(s) tal como aparecen en la identificación oficial",
            "min": "Tu nombre debe tener mínimo 2 caracteres.",
            "alpha_spaces": "El campo solo puede contener letras."
        },
        "last_name": {
            "required": "Escribe sus apellidos tal como aparecen en su identificación oficial",
            "min": "Tu apellido debe tener mínimo 2 caracteres.",
            "alpha_spaces": "El campo solo puede contener letras."
        },
        "email": {
            "required": "Ingresa un correo válido.",
            "email": "Verifica que tu correo tenga un formato válido: ejemplo@dominio.com",
            "alpha_spaces": ""
        },
        "confirm_email": {
            "required": "Confirma tu correo electrónico.",
            "email": "Verifica que tu correo tenga un formato válido: ejemplo@dominio.com",
            "alpha_spaces": "",
            "confirmed": "El campo no concuerda",
        },
        "phone": {
            "required": "Ingresa tu número de teléfono a 10 dígitos.",
            "min": "El número debe tener al menos 10 dígitos.",
            "integer": "El número no debe exceder los 15 dígitos.",
            "alpha_spaces": "",
            "The field is not valid": "El número de teléfono debe tener entre 7 y 15 dígitos."
        },
        "day": {
            "required": "¿Cuál es tu día de nacimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un día válido",
        },
        "month": {
            "required": "¿Cuál es tu mes de nacimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un mes válido",
        },
        "year": {
            "required": "¿Cuál es tu año de nacimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un año válido",
        },
        "dayPassport": {
            "required": "¿Cuál es el día de vencimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un día válido",
        },
        "monthPassport": {
            "required": "¿Cuál es el mes de vencimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un mes válido",
        },
        "yearPassport": {
            "required": "¿Cuál es el año de vencimiento?",
            "is_not": "Selecciona un día válido.",
            "The field is not valid": "Selecciona un año válido",
        },
        "genrer": {
            "required": "Selecciona el genero que aparece en su identificación oficial.",
        },
        "nationality": {
            "required": "¿Cuál es tu nacionalidad?",
        },
        "passport": {
            "required": "¿Cuál es tu pasaporte?",
        },
        "locator": {
            "required": "Ingresa un número de reservación válido",
            "The field is not valid": "Ingresa un número de reservación válido",
        },
        "invoice_generic": {
            "required": "Ingresa un valor válido",
            "The field is not valid": "Ingresa un valor válido",
            "nit_format": "Ingresa NIT/RUT con dígito de verificación (Ej: 900123456-7)",
            "email": "Ingresa un correo electrónico válido",
        },
        "birthdate": {
            "date_invalid": "La fecha ingresada no es válida",
            "date_expiration": "Fecha de vencimiento inválida",
            "required": "Escribe su fecha de nacimiento tal y como aparece en su identificación oficial."
        },
        "passport": {
            "alpha_num_strict": "El pasaporte ingresado no es válido"
        },
        "identity": {
            "alpha_num_strict": "La cédula de ciudadanía ingresada no es válida"
        },
        "arrival_airline": {
            "required": "La aerolínea es obligatoria",
            "min": "La aerolínea debe tener mínimo 2 caracteres.",
            "alpha_spaces": "El campo solo puede contener letras."
        },
        "arrival_flight_number": {
            "required": "El número de vuelo es obligatorio",
            "alpha_num": "El número de vuelo debe ser alfanumérico",
            "regex": "El número de vuelo debe ser alfanumérico y puede incluir espacios",
            "The field is not valid": "Ingresa un número de vuelo válido",
        },
        "departure_airline": {
            "required": "La aerolínea es obligatoria",
            "min": "La aerolínea debe tener mínimo 2 caracteres.",
            "alpha_spaces": "El campo solo puede contener letras."
        },
        "departure_flight_number": {
            "required": "El número de vuelo es obligatorio",
            "alpha_num": "El número de vuelo debe ser alfanumérico",
            "regex": "El número de vuelo debe ser alfanumérico y puede incluir espacios",
            "The field is not valid": "Ingresa un número de vuelo válido",
        },
        "billing_Name": {
            "required": "Escribe tu nombre completo / razón social tal como aparecen en tus documentos oficiales.",
            "alpha_spaces": "El campo solo puede contener letras."
        },
        "id_type": {
            "required": "Selecciona el tipo de documento que aparece en su identificación oficial.",
        },
        "id_number": {
            "required": "Ingresa tu número de documento / NIT / RUT.",
            "The field is not valid": "Ingresa un valor valido",
            "nit_format": "Ingresa NIT/RUT con dígito de verificación (Ej: 900123456-7)",
        },
    },
    "formaters": {
        "cancellation": "LLLL",
        "rapd": "dddd D, MMM YYYY <br> HH:mm",
        "rapdstep1": "dddd D, MMM YYYY <br> HH:mm",
        "cancel_free": "D MMM, YYYY",
        "rapdstep3": 'dddd DD, MMM YYYY,',
        "formathrs": "Tiempo del Centro de México",
        "formathrsstep1": "hrs <br><span class=\"text-subtle font-12\">Tiempo del Centro de México </span>",
        "deposit": 'dddd DD, MMM YYYY, HH:mm',
    },
    "checkout": {
        "note_charge": "Las tarifas en {0} son informativas y se basan en el tipo de cambio actual.",
        "pay_will_be": "Pagarás ",
        "pay_will_be_meta": "Pagarás "
    },
    "breadcrumbs": {
        "home": "Inicio",
        "info": "Información del sitio",
        "about-us": "Acerca de nosotros",
        "legal": "Legal",
        "terms-and-conditions": "Términos y condiciones",
        "privacy-policy": "Política de Privacidad",
        "profeco-contract": "Contrato de Adhesión Profeco",
        "mx": "México",
        "global": "USA y Resto del mundo",
        "user": "Cuenta",
        "profile": "Información personal",
        "companions": "Personas adicionales",
        "security": "Seguridad de tu cuenta",
        "reservations": "Reservas y viajes",
        "usuario": "Cuenta",
        "perfil": "Información personal",
        "acompanantes": "Personas adicionales",
        "seguridad": "Seguridad de tu cuenta",
        "reservaciones": "Reservas y viajes",
        "payment-methods": "Métodos de pago",
        "invoices": "Información de Facturación",
        "reviews-policy": "Política de comentarios",
    },
    "information": {
        "lang_es": "Español",
        "lang_us": "Inglés",
        "mx": "México",
        "us": "Estados Unidos",
        "co": "Colombia",
        "faq": "Preguntas Frecuentes",
        "about_us_title": "Te damos la bienvenida a {0}.com",
        "no_results": "Sin resultados",
        "select_location": "Selecciona tu ubicación",
        "site_information": "Información del sitio",
        "payment_methods": "Formas de pago",
        "payment_methods_description": "Conoce los métodos de pago disponibles",
        "billing": "Facturación",
        "billing_description": "Conoce cómo obtener fácilmente la factura de tu reservación",
        "about_site": "Acerca de",
        "about_site_description": "Descubre más sobre nuestra empresa, misión y valores",
        "reviews_policy_title": "Política de comentarios",
        "reviews_policy_description": "Conoce nuestra política sobre comentarios y reseñas de usuarios",
    },
    "security": {
        "email_subtitle": "Este es el correo que usas para iniciar sesión y en el que recibes la confirmación de tus reservaciones",
        "verified": "Verificado",
        "password": "Contraseña",
        "change": "Cambiar",
        "modify_password": "Modificar contraseña",
        "check_inbox": "Revisa tu bandeja de entrada",
        "password_instructions": "Enviaremos un correo con las instrucciones para cambiar tu contraseña a:",
        "password_instructions_sent": "Enviamos un correo con las instrucciones para cambiar tu contraseña a:",
        "email_valid_time": "Una vez que llegue, será válido por 60 minutos",
        "send": "Enviar",
        "resend": "Reenviar"
    },
    "profile": {
        "profile": "Información personal",
        "session_name": "Nombre",
        "pending": "Pendiente",
        "edit": "Editar",
        "first_name": "Nombre(s)",
        "last_name": "Apellido(s)",
        "cancel": "Cancelar",
        "update_perfil": "Se ha guardado correctamente",
        "error_ocurred": "Ha ocurrido un error al procesar tu solicitud",
        "phone_login": "Teléfono",
        "birthdate": "Fecha de nacimiento",
        "nationality": "Nacionalidad",
        "genre": "Género",
        "account_security": "Seguridad de tu cuenta",
        "account_email_message": "Correo",
        "header_redirect": "Volver al inicio",
        "email": "Correo electrónico",
        "passport": "Pasaporte",
        "previus": "Anterior",
        "next": "Siguiente",
        "day": "Día",
        "month": "Mes",
        "year": "Año",
        "man": "Masculino",
        "fem": "Femenino",
        "na": "No especificar",
        "optional": "Opcional",
        "paxes_subtitle": "Agrega la información de las personas que te acompañan en tus viajes.",
        "add_paxes": "Agregar persona",
        "new_companion": "Persona adicional",
        "edit_companion": "Editar persona adicional",
        "save": "Guardar",
        "delete_paxe": "Borrar acompañante",
        "terms": "Al seleccionar 'Guardar', aceptas que {0}.com conserve los datos ingresados",
        "message_important": "Escribe los datos tal como aparecen en su identificación oficial",
        "account": "Cuenta",
        "reservations": "Reservaciones",
        "warningDelete": "¿Estás seguro de querer eliminar este acompañante?",
        "warningDeleteCard": "¿Estás seguro de querer eliminar este tarjeta?",
        "accept": "Aceptar",
        "dateInvalid": "Introduce una fecha de nacimiento válida (anterior a hoy).",
        "phone__messages": "Este número podríamos llamarte para cualquier tema relacionado a tus reservaciones.",
        "cal_placeholder": "DD / MM / AAAA",
        "add_method_payment": "Agrega métodos de pago de forma segura para agilizar el proceso de reserva.",
        "add_card": "Agregar tarjeta",
        "new_card_title": "Nueva tarjeta",
        "default_card": "Tarjeta predeterminada",
        "edit_card_title": "Editar tarjeta",
        "expiration_card": "Vencida",
        "attention": "Atención",
        "errorDeleteCard": "Ha ocurrido un error al eliminar la tarjeta, si continua el error por favor comunicarse a atención a cliente",
        "identity": "Cédula de ciudadanía",
        "travel_documents": "Documentos de Viaje",
        "passport_number": "Número de pasaporte",
        "issuing_country": "País de emisión",
        "expiration_date": "Fecha de vencimiento"
    },
    "account": {
        "go_back": "Regresar",
        "greeting_user": "¡Hola,",
        "account_welcome_message": "Bienvenido a tu cuenta {0}. Administra y revisa la información de tus viajes.",

        "complete_personal_info_title": "Completa tus datos personales",
        "complete_personal_info_description": "Guarda tus datos y olvídate de escribirlos cada vez que reserves. Más rápido, más fácil.",
        "complete_now_cta": "Completar ahora",

        "account_title": "Cuenta",
        "account_description": "Guarda tus datos y olvídate de escribirlos cada vez que reserves. Más rápido, más fácil.",
        "profile_title": "Datos personales",
        "security_title": "Seguridad de tu cuenta",
        "additional_title": "Personas adicionales",
        "payment_title": "Formas de pago",
        "invoices_title": "Información de facturación",
        "invoice_description": "Consulta tu factura de tus reservaciones.",
        "trips_title": "Viajes",
        "trips_description": "Consulta tus viajes y guarda tus favoritos para reservarlos cuando quieras.",
        "reservations_title": "Reservas y viajes",
        "favorites_title": "Favoritos",

    },
    "reservations": {
        "reservation_trips": "Reservas y viajes",
        "cant_find_reservation": "¿No encuentras alguna reserva?",
        "ok": "Confirmada",
        "progress": "Pendiente de pago",
        "past": "Pasados",
        "cancelled": "Cancelados",
        "locator": "No. de reservación",
        "where_to_go": "¿A dónde te gustaría ir?",
        "no_upcoming_trips": "Aún no tienes viajes próximos ",
        "search_trip_options": "Buscar opciones de viaje",
        "cant_find_reservation": "¿No encuentras alguna reserva?",
        "Cancel": "Cancelada",
        "completed": "Confirmada",
        "quote": "Cotizaciones",
        "see_itinerary": "Ver itinerario",
        "pay_reservation": "Pagar reservación",
        "total": "Total por pagar",
        "upcoming": "Próximos",
        "progressTitle": "Pendientes de pago",
        "new_reservation": "Indica datos de la reseva",
        "instructions": "Si tienes otra reservación y no aparece en lista puedes agregarla.",
        "not_found": "Revisa tu número de reservación y correo electrónico y vuelve a ingresar los datos.",
        "error_sync": "Lo sentimos, no pudimos localizar tu reservación con los datos ingresados. Intenta nuevamente o contacta a nuestro centro de atención.",
        "email_instruction": "El que usaste al momento de reservar",
        "localizator": "Número de reservación",
        "email": "Correo electrónico",
        "email_placeholder": "correo@gmail.com",
        "search": "Buscar",
        "cancel": "Cancelar",
        "trash": "Cancelada",
        "cant_find_url_payment": "Ocurrió un problema al tratar de pagar la reserva, puede estar cancelada o ya no disponible",
        "noResults": "No se encontraron coincidencias",
        "cant_find_reservation_error": "No se pudo importar esta reserva debido a que no es válida para este proceso. Intenta con otra reserva.",
        "not_found_title": "Reserva no encontrada",
        "error_sync_title": "Ocurrió un error",
        "nothing_reservations": "{0}, aún no tienes viajes próximos",
        "nothing_reservations_sub": "¿A dónde te gustaría ir?",
        "nothing_upcoming": "Aún no tienes viajes próximos",
        "nothing_upcoming_subtitle": "¿Listo para tu próxima aventura, {0}?",
        "nothing_pending-payment": "Sin pendientes de pago",
        "nothing_pending-payment_subtitle": "¡Todo en orden, {0}! <br> No tienes reservas por pagar en este momento.",
        "nothing_past": "Aún no tienes viajes pasados",
        "nothing_past_subtitle": "Cuando regreses de tu primer viaje, <br> aparecerá aquí para que lo recuerdes.",
        "nothing_cancelled": "No tienes viajes cancelados",
        "nothing_cancelled_subtitle": "Aquí aparecerán tus reservas canceladas",
        "quotes_side_title": "¡Tu escapada aún te espera!",
        "quotes_side_subtitle": "Retoma tu reservación y hazla realidad.",
        "continue_booking": "Continua tu reservación",
        "warning_reservation": "Aviso de reserva pendiente",
        "saved_reservations": "Cotizaciones guardadas",
        "categories_reservations": "Categorías de reservaciones",
        "back_button": "Regresar a la página anterior",
        "btn_continue_reservation": "Continuar reservación - abrir la reservación guardada",
        "tooltip__search_reservation": "Lo encuentras en el correo electrónico de confirmación de tu reserva.",
        "tooltip__search_context_reservation": "Tu Localizador te sirve para dar seguimiento y consultar cualquier información acerca de tu reservación.",
        "alt_img_cards": "Foto panorama",
        "title_hotel": "Hotel",
        "title_flight": "Vuelo",
        "title_package": "Paquete",
        "title_transfer": "Traslado",
        "title_tour": "Tour",
        "title_rentals": "Alojamiento",

    },
    "legal": {
        "legal_info": "Información legal",
        "mx": "México",
        "global": "USA y Resto del mundo",
        "on_this_page_mx": "En esta página",
        "on_this_page_global": "On this page",
        "terms_and_conditions": "Términos y condiciones",
        "terms_and_conditions_mx": "Términos y condiciones",
        "terms_and_conditions_global": "Terms and Conditions",
        "terms_conditions_description": "Revisa los términos y condiciones que aplican a {0}.",
        "terms_conditions_notification_mx": "Si tu país de residencia es distinto a México o realizaste una reservación en el sitio fuera de México, la <a href='{0}'>Política de privacidad USA y Resto del mundo</a> aplica para ti.",
        "terms_conditions_notification_global": "Si tu país de residencia es México o realizaste una reservación en el sitio desde México, la <a href='{0}'>Política de privacidad México</a> aplica para ti.",
        "privacy_policy": "Política de privacidad",
        "privacy_policy_mx": "Política de privacidad",
        "privacy_policy_global": "Privacy Policy",
        "privacy_policy_description": "Conoce como cuidamos los datos que nos proporcionas a través de nuestros canales.",
        "profeco_contract_mx": "Contrato de Adhesión Profeco",
        "profeco_contract_description": "Información para compradores en México",
    },
    "months": {
        "01": "Enero",
        "02": "Febrero",
        "03": "Marzo",
        "04": "Abril",
        "05": "Mayo",
        "06": "Junio",
        "07": "Julio",
        "08": "Agosto",
        "09": "Septiembre",
        "10": "Octubre",
        "11": "Noviembre",
        "12": "Diciembre",
    },
    "payment": {
        "payOnline-title": "Pago en línea",
        "email_typo_suggestion": "¿Quisiste decir",
        "payOnline-subtitle": "Ingrese su localizador y pague en línea. (Recibimos todas las tarjetas Débito y Crédito).",
        "payOnline-code": "Localizador",
        "payOnline-email": "Email (el que usó para reservar)",
        "payOnline-consult": "Consultar",
        "secure-payments": "Pagos cómodos y seguros",
        "check-methods-pay": "Consulta nuestras formas de pago",
        "payment-option-depend": "*Las opciones de pagos a cuotas dependen del servicio seleccionado y el valor de la compra",
        "payOnline-codePlaceHolder": "Ej. 129668555",
        "payOnline-emailPlaceholder": "Ej. ejemplo@correo.com",
        "method_payments": "Métodos de pago",
        "tc_td": "Aceptamos todas las tarjetas de crédito y débito",
        "until": "Hasta",
        "quotas": "cuotas",
        "payments_options": "Las opciones de pago a plazos dependen del servicio seleccionado y del valor de la compra",
        "have_credit_card": "¿No tienes una tarjeta de crédito?",
        "more_payments_methods": "Tenemos más métodos de pago:",
        "bancolombia_btn": "Botón Bancolombia",
        "bancolombia_pay_online": "Paga en línea con tu cuenta de ahorros o corriente de Bancolombia",
        "PSE_payment": "Pago en línea con PSE",
        "PSE_pay_online": "Paga en línea con tu cuenta corriente o de ahorros",
        "cash": "Efectivo",
        "pay_cash": "Paga en efectivo en tu ubicación más cercana:",
        "effecty_pay": "Paga en efectivo con el código de recaudo 112232 y la referencia de pago en cualquier punto Efecty a nivel nacional",
        "bank_deposit": "Depósito bancario",
        "deposit_pay": "Paga en línea con tu cuenta corriente o de ahorros",
        "what_includes": "¿Qué incluye esta tarifa?",
        "consult": "Consultar",
        "title_token": "Los datos de su reserva son los siguientes",
        "description": "Sr(a) {0}, en caso de dudas puede contactarnos a nuestra línea de atención:",
        "tel_tiquetesbaratos": "<a href='tel:6017436620'>601 743 6620 </a>",
        "tel_pricetravel": "<a href='tel:8552468484'>(855) 246 8484 </a>",
        "owner_name": "A nombre de",
        "owner_email": "Correo electrónico",
        "total_amount": "Por un valor de",
        "go_back": "Regresar al inicio",
        "create_link": "Proceder a pagar",
        "error": "Ha ocurrido un error al consultar los datos de la reserva",
        "cancelled": "La reservación ha sido cancelada",
        "not_found": "No hemos encontrado la reservación.",
        "success": "Tus datos de reservación",
        "description_cancelled": "Puede intentar creando un nueva reservacion desde nuestro portal, en caso de dudas puede contactarnos a nuestra línea de atención",
        "description_not_found": "Por favor, verifica que los datos ingresados sean correctos. Si necesitas ayuda, no dudes en contactarnos a nuestra línea de atención:",
        "paid_amount": "Valor saldado",
        "balance_amount": "Pendiente por saldar",
        "try_again": "Intenta de nuevo",
        "without_results": "Sin resultados",
        "recaptcha_error": "Por favor, confirma que no eres un robot",
        "error_email": "Ingresa un correo válido",
        "error_locator": "Ingresa un localizador válido",
        "modal_payment_title": "Formas de pago",
        "modal_payment_card_title": "Tarjetas de crédito y débito",
        "modal_payment_TC_promotion": "Promociones con tarjetas de crédito",
        "modal_payment_months": "Meses",
        "modal_payment_months_interest": "sin intereses",
        "modal_payment_warning": "Las opciones de meses sin intereses y pagos fijos dependen del servicio seleccionado y el valor de la compra. Monto mínimo de compra MXN$ 1,200 para MSI y pagos fijos.",
        "modal_payment_digital_wallet": "Wallets digitales",
        "modal_payment_restriction_moment": "Aplican restricciones al momento de la compra",
        "flights": "Vuelos",
        "modal_payment_until": "Hasta ",
        "payment_description_interest": "meses sin intereses",
        "hotels": "Hoteles",
        "modal_payment_and": "y",
        "packages_name": "Paquetes",
        "bank_deposit_transfer": "Depósito o Transferencia bancaria",
        "bank_deposit_transfer_description": "Cuando termines tu compra, te daremos las instrucciones para realizar el pago en el banco de tu preferencia.",
        "pay_at_pdv": "Pago en punto de venta {0}",
        "pay_at_pdv_description": "Si lo prefieres puedes pagar directamente en cualquiera de nuestros ",
        "pdv_locations": "puntos de venta físicos",
        "modaltb_payment_title": "Formas de pago",
        "modaltb_payment_card_title": "Tarjetas de crédito y débito",
        "modaltb_payment_until": "Hasta",
        "modaltb_payment_warning": "Las opciones de pagos a cuotas dependen del servicio seleccionado y el valor de la compra.",
        "modaltb_payment_no_card_title": "¿No cuentas con tarjeta de crédito?",
        "modaltb_payment_other_methods": "Tenemos más formas de pago:",
        "modaltb_payment_bancolombia": "Paga en línea con tu cuenta de ahorro o corriente de Bancolombia",
        "modaltb_payment_pse_title": "Pago en línea con PSE",
        "modaltb_payment_pse_description": "Paga en línea con tu cuenta corriente o de ahorros",
        "modaltb_payment_cash_title": "Paga en efectivo",
        "modaltb_payment_cash_description": "Paga en efectivo en tu lugar más cercano",
        "modaltb_payment_efecty": "Paga en efectivo con el código de recaudo 112232 y la referencia de pago en cualquier punto Efecty a nivel nacional",
        "modaltb_payment_bank_deposit": "Depósito bancario",
        "pay_best_optionstb": "Pagos cómodos y seguros",
        "pay_best_options": "Reserva con las mejores opciones de pago",
        "get_our_payment_methods": "Más formas de pago",
        "get_our_payment_methodstb": "Consulta nuestras formas de pago",
    },
    "cta": {
        "register_hotel": "¡Convierte tu alojamiento en un generador de reservas!",
        "register_hotel_description": "Anúncialo en <strong>{0}</strong> y conecta con viajeros de todo el mundo.",
        "register_hotel_cta": "Descubre como"
    },
    "recap": {
        "available_now": "Ya están disponibles",
        "my_travel_memory": "Tus memorias de viaje",
        "view_my_travel": "Ver tu recorrido",
        "available_now": "¿Ya sabes a dónde ir?",
        "my_travel_memory": "Revive tus memorias de viaje",
        "your_travel_memories_description": "Inspírate y descubre nuevos destinos pensados para ti.",
        "view_my_travel": "Ver mi recorrido",
        "view_my_travel_description": "Ver mi recorrido de viaje",
        "recap_illustration": "Ilustración decorativa de viaje",
        "recap_memory": "Foto de recuerdo de viaje",
    },
    "booker": {
        "cancel": "Cancelar",
        "apply": "Aplicar",
        "increment": "Aumentar",
        "decrement": "Disminuir",
        "error_children": "Seleccione la edad del niño",
        "childred_age": "Edad",
        "adults": "Adultos",
        "adults_subtle": "Desde 18 años",
        "flight_adults_subtle": "Desde 12 años",
        "childrens": "Menores",
        "childrens_subtle": "Hasta {0} años",
        "rooms": "Habitaciones",
        "rooms_subtle": "Total de habitaciones'",
        "years": "años",
        "year": "año",
        "age_minor": "Edad menor",
        "minors_23": "0 a 23 meses",
        "remove": "Quitar",
        "add_room": "Agregar habitación",
        "room": "Habitación",
        "where_are_you_going": "Destino, hotel, punto de interés.",
        "where_are_you_going_sub": "¿A dónde quieres viajar?",
        "destination_placeholder": "Destino, hotel, punto de interés.",
        "dates": "Fechas",
        "guests": "Huéspedes",
        "guests_sub": "Elige tus huéspedes",
        "passengers": "Pasajeros",
        "passengers_sub": "Elige tus pasajeros",
        "accommodations": "Búsqueda de alojamientos",
        "flights": "Búsqueda de vuelos",
        "origin": "Origen",
        "origin_sub": "Elige tu aeropuerto de origen",
        "destination": "Destino",
        "destination_sub": "Elige tu destino",
        "departure": "Ida",
        "return": "Regreso",
        "date": "Fecha",
        "button": "Buscar",
        "type": "Tipo de vuelo:",
        "round_trip_pricetravel": "Redondo",
        "round_trip_tiquetesbaratos": "Ida y regreso",
        "one_way_pricetravel": "Sencillo",
        "one_way_tiquetesbaratos": "Solo Ida",
        "select_origin": "Selecciona un origen",
        "select_destination": "Selecciona un destino",
        "select_dates": "Selecciona fechas",
        "select_guests": "Selecciona huéspedes",
        "select_different_destination": "Selecciona un destino diferente",
        "max_paxes": "En viajes de más de 5 personas te recomendamos agregar otra habitación para tener más opciones de hospedaje.",
        "max_paxes_global": "Máximo {0} pasajeros por reserva. Para agregar más pasajeros, haz otra reserva o comunícate con atención a cliente.",
        "no_destinations_found": "No se encontraron destinos",
        "search_destination": "Buscar destino",
        "where_do_you_want_to_go": "¿A dónde quieres ir?",
        "popular_destinations": "Destinos más buscados",
        "popular_destinations_origin": "Origenes más buscados",
        "all_airports": "Todos los aeropuertos",
        "notificationKids": "Debe haber al menos 1 pasajero (Adulto) por cada bebe en brazos.",
        "recent_searches": "Búsquedas recientes",
        "calendar_date": "Fecha",
        "calendar_arrival": "Llegada",
        "calendar_departure": "Salida",
        "calendar_nights": "noches",
        "calendar_night": "noche",
        "calendar_days": "días",
        "calendar_day": "día",
        "calendar_omit": "Cancelar",
        "calendar_total": "Total",
        "low_prices": "Precios bajos",
        "lower_prices": "Precios muy bajos",
        "price_disclaimer": "Precios aproximados en {0} por {1} para 2 adultos",
        "calendar_nav": "Navegación del calendario",
        "next_month": "Mes siguiente",
        "prev_month": "Mes anterior",
        "unavailable": "No disponible",
        "start_date": "Fecha de inicio",
        "end_date": "Fecha final",
        "payment_summary": "Resumen de Pago",
        "additional_charges": "Cargos Adicionales",
        "length_of_stay": "Duración de estancia",
        "you_selected": "Seleccionaste",
        "persons": "personas",
        "cancellation_policies": "Políticas de cancelación",
        "cancellation_policies_desc": "Puedes modificar o cancelar tu reserva sin costo dentro del plazo permitido; después de esa fecha, podrían aplicarse cargos según las condiciones del alojamiento.",
        "see_more_info": "Ver más información",
        "adults": "Adultos",
        "adult": "Adulto",
        "refund_full": "Reembolso total",
        "refund_partial": "Reembolso parcial",
        "refund_none": "Sin reembolso",
        "refund_full_desc": "Recibe un reembolso del 100% de lo que pagaste.",
        "refund_partial_desc": "Recibirás el {penalty}% de todas las noches. No se te reembolsará la tarifa de servicio.",
        "refund_none_desc": "Esta reservación no es reembolsable.",
        "cancel_before": "Antes de las",
        "cancel_after": "Después de las",
        "cancel_time_note": "La hora indicada se basa en la ubicación correspondiente al anuncio.",
        "cancel_requirements_title": "Requisitos para recibir un reembolso",
        "cancel_requirements_desc": "Si tienes pagos programados, el reembolso o el importe que te corresponda dependerá de cuánto hayas pagado al momento de la cancelación.",
        "until": "Hasta",
        "from_date": "Del",
        "rate_change_title": "Actualización de tarifa",
        "rate_change_description": "El precio de este alojamiento ha cambiado desde tu búsqueda.",
        "rate_change_original": "Precio original",
        "rate_change_new": "Nuevo precio",
        "rate_change_increased": "El precio ha aumentado",
        "rate_change_decreased": "¡Buenas noticias! El precio bajó",
        "rate_change_accept": "Entendido, continuar",
        "sold_out_title": "Sin disponibilidad",
        "sold_out_description": "Lo sentimos, este alojamiento ya no tiene disponibilidad para las fechas seleccionadas. Te invitamos a explorar otras opciones.",
        "sold_out_button": "Ver otros alojamientos",
        "nearby_location": "Cerca de tu ubicación actual",
        "nearby_location_name": "Cerca de {0}"
    },
    "accommodation": {
        "accommodation": "Alojamiento",
        "accommodation_gallery": "Galería de alojamiento",
        "go_back": "Regresar",
        "go_back_to": "Regresar a",
        "adult": "Adulto",
        "view_all_photos": "Ver todas las fotos",
        "location": "Ubicación",
        "open_gallery": "Abrir galeria",
        "information": "Información",
        "services": "Servicios",
        "calendar": "Calendario",
        "host": "Anfitrión",
        "share": "Compartir",
        "save_to_favorites": "Guardar en favoritos",
        "share_this_accommodation": "Comparte este alojamiento",
        "share_via_facebook": "Compartir vía Facebook",
        "share_via_whatsapp": "Compartir vía WhatsApp",
        "copy_link": "Copiar enlace",
        "link_copied": "Enlace copiado",
        "menu": "Menú de alojamiento",
        "select_dates": "Selecciona tus fechas",
        "price_per_night": "Precio por noche",
        "book_now": "Reservar ahora",
        "modify_search": "Modificar búsqueda",
        "free_cancellation": "Cancelación gratis",
        "where_you_will_be": "¿Dónde vas a estar?",
        "cancellation_policy": "Políticas de cancelación",
        "can_cancel_free_until": "Puedes cancelar sin cargos hasta el",
        "destination_time": "hora del destino",
        "if_cancel_after": "Si cancelas después del",
        "no_show_penalty_total": "o no te presentas, se aplicará una penalización equivalente al costo total de la reservación.",
        "if_cancel_between": "Si cancelas entre el",
        "and": " y el ",
        "penalty_is": "la penalización será de",
        "partial_cancellation": "Cancelación con cargo",
        "can_cancel_with_charge_until": "Puedes cancelar con un cargo de",
        "until": "hasta el",
        "total_final": "Total final",
        "total": "Total",
        "payment_summary": "Resumen de pago",
        "additional_charges": "Cargos adicionales",
        "cancellation_policies": "Políticas de cancelación",
        "cancellation_policies_desc": "Puedes modificar o cancelar tu reserva sin costo dentro del plazo permitido; Después de esa fecha, podrían aplicarse cargos según las condiciones del alojamiento.",
        "see_more_info": "Ver más información",
        "adults": "Adultos",
        "refund_full": "Reembolso total",
        "refund_partial": "Reembolso parcial",
        "refund_none": "Sin reembolso",
        "refund_full_desc": "Recibe un reembolso del 100% de lo que pagaste.",
        "refund_partial_desc": "Recibirás el {penalty}% de todas las noches. No se te reembolsará la tarifa de servicio.",
        "refund_none_desc": "Esta reservación no es reembolsable.",
        "cancel_before": "Antes de las",
        "cancel_after": "Después de las",
        "cancel_time_note": "La hora indicada se basa en la ubicación correspondiente al anuncio.",
        "cancel_requirements_title": "Requisitos para recibir un reembolso",
        "cancel_requirements_desc": "Si tienes pagos programados, el reembolso o el importe que te corresponda dependerá de cuánto hayas pagado al momento de la cancelación.",
        "rate_change_title": "Actualización de tarifa",
        "rate_change_description": "El precio de este alojamiento ha cambiado desde tu búsqueda.",
        "rate_nofound_description": "Lo sentimos, la disponibilidad del hospedaje se ha ocupado, intenta con otras fechas.",
        "rate_change_original": "Precio original",
        "rate_change_new": "Nuevo precio",
        "rate_change_increased": "El precio ha aumentado",
        "rate_change_decreased": "¡Buenas noticias! El precio bajó",
        "rate_change_accept": "Entendido, continuar",
        "all": "Todas",
        "all_images": "Todas las imágenes"
    },
    "favorites": {
        "favorites": "Favoritos",
        "loading_favorites": "Cargando favoritos",
        "follow_these_steps": "Sigue estos 2 simples pasos para comenzar",
        "favorite_step_1": "Busca un alojamiento de tu preferencia",
        "favorite_step_2": "Durante tu búsqueda, toca el corazón para guardar tus hoteles favoritos",
        "here_are_your_favs": "¡Aquí encontrarás los alojamientos guardados!",
        "search": "Buscar",
        "hotels": "Hoteles",
        "some_hotels_cheaper": "Alguno de tus hoteles favoritos bajó de precio",
        "favorite_hotels": "",
        "the_hotel": "El hotel",
        "deleted_from": "se ha eliminado de tu",
        "fav_list": "lista de favoritos",
        "undo": "Deshacer",
        "add_to_favs": "Añadir a favoritos",
        "people_lower": "personas",
        "people_lower_1": "persona",
        "room_favs": "habitación",
        "list_rooms": "habitaciones",
        "hotel_price_decreased": "El precio bajó",
        "hotel_price_increased": "El precio subió",
        "list_room_per_night": "Habitación por noche",
        "list_room_per_night_low": "Precio anterior",
        "fav_card_dates_expired": "Ver fechas disponibles",
        "go_back": "Regresar"
    },
    "invoice": {
        "title": "Información de facturación",
        "subtitle": "Agrega tu información de facturación de forma sencilla para facilitar tus reservas.",
        "add_button": "Agregar datos fiscales",
        "add_invoice": "Agregar datos fiscales",
        "edit_invoice": "Editar",
        "invoice_info": "Información de facturación",
        "billing_info": "Ingresa tus datos de facturación tal como aparecen en tus documentos oficiales.",
        "billing_Name": "Nombre completo / Razón social",
        "placeholder_billing_Name": "Nombre completo / Razón social",
        "id_type": "Documento de identidad",
        "placeholder_id_type": "Seleccionar un documento",
        "id_number_tiquetesbaratos": "Número de documento / NIT / RUT",
        "id_number_pricetravel": "Número de documento / RFC / Tax ID",
        "placeholder_id_number_1": "Ej. 900123456-7",
        "placeholder_id_number_2": "Ej. ABC123456789",
        "save": "Guardar",
        "update": "Actualizar",
        "cancel": "Cancelar",
        "delete_invoice": "Eliminar datos de facturación",
        "noResults": "No se encontraron resultados",
        "email": "Correo electrónico de facturación",
        "placeholder_email": "Correo electrónico de facturación"

    }
};
